module.exports = __webpack_public_path__ + "static/viewImage-7b0ddc001e982b7fd88c61fdc4d1dab4.jpg";